import { Lock } from "lucide-react";

interface LockOverlayProps {
  unlockMessage: string;
}

export const LockOverlay = ({ unlockMessage }: LockOverlayProps) => {
  return (
    <div className="absolute inset-0 bg-white/90 backdrop-blur-sm rounded-2xl flex flex-col items-center justify-center gap-3 z-10 transition-all duration-200">
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gray-100">
        <Lock className="w-8 h-8 text-gray-400" />
      </div>
      <p className="text-sm font-semibold text-gray-600 text-center px-4">
        {unlockMessage}
      </p>
    </div>
  );
};
